import moment from 'moment';

export default {
    redirectOnResetPassword (){
        return 'dashboard';
    },

    currentSearchTerm: (state, getters) => {
        return state.searchTerm;
    },
    displayChooseEntityFullOverlay(){
        // DO NOT DISPLAY view Choose Entity
        return false;
    },

    displayAuthFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.userIsAuthenticated;
    },

    displayLoadingFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableGroupsAdministration(){
        return true;
    },
    enableUsersAdministration(){
        return true;
    },
    enablePermissionAdministration(){
        return true;
    },
    enableGroupsSideBarMenu(){
        return true;
    },
    enableUsersSideBarMenu(){
        return true;
    },
    enableDownloadCsvGroups(){
        return false;
    },
    enableDownloadCsvUsers(){
        return false;
    },
    enableRegister(){
        return false;
    },
    enableResetPassword(){
        return false;
    },
    enableSidebarCollapse(){
        return false;
    },
    enableLoginByEmail(){
        return false;
    },
    enableCreateUser(){
        return false;
    },
    enableCreateGroup(){
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },

    getWw (state){
        return state.ww;
    },
    currentEntity (state){
        return state.currentEntity;
    },
    currentTaker (state, getters){
        if(getters.takers.length > 1){
            return state.currentTaker;
        }
        return getters.takers[0];
    },

    currentTakerConfiguration (state, getters){
        return getters.configurations.filter((conf) => conf.taker_uid === getters.currentTaker.uid);
    },

    entities_get(){
        return {
            name: {
                presence: true,
                type: 'string'
            },
            display_name: {
                presence: true,
                type: {
                    type: 'string',
                    message: (value)=>{
                        return `: Wrong type, string expected, got ${typeof(value)}`;
                    }
                }
            },
            activate_universes: {
                presence: true,
                type: 'boolean'
            },
            show_all_universes: {
                presence: true,
                type: 'boolean'
            },
            logo: {
                presence: true,
                type: 'string'
            },
            image: {
                presence: true,
                type: 'string'
            },
        };
    },
    irds_get(){
        return {
            name: {
                presence: true,
                type: {
                    type: 'string',
                    message: (value)=>{
                        return `: Wrong type, string expected, got      ${typeof(value)}`;
                    }
                }
            },
        };
    },
    scopedModels (state){
        let scopedModel = [];
        for(let modelKey in state.api.meta.listModels){
            if(state.api.meta.listModels[modelKey].scoped){
                scopedModel.push(modelKey);
            }
        }
        return scopedModel;
    },
    nextFeedStartDate:() =>  (feedsWithRight) => {
        // Get feeds starts date
        let feedsStartDates = feedsWithRight.map(
            feed => {
                return moment.utc(feed[feed.confirmed ? 'confirmed_start_date' : 'start_date' ]);
            }
        );
        // Filter only future feeds
        feedsStartDates = feedsStartDates.filter(
            startDate => startDate.isAfter()
        );
        // return null if no feedsStartDates
        if(feedsStartDates.length === 0){
            return null;
        };
        // retrieve closest start date
        let next = moment.min(feedsStartDates);
        if(next.isValid() === false){
            return null;
        }
        return next;
    },
    userIsEntityAdmin : (state, getters) =>(entityUid=null, userToCheck=null)=>{
        let user = userToCheck?userToCheck:getters.currentUser;
        let currentUserIsEntityAdmin = false;
        if(user.level.toLowerCase() === 'simpleuser'){
            return false;
        }
        if(entityUid){
            currentUserIsEntityAdmin = getters.groups.some(
                group =>
                    group.is_admin_group === true
                    && group.entity_uid === entityUid
                    && group.members_uid.includes(user.uid)
            );
        }else{
            currentUserIsEntityAdmin = getters.groups.some(
                group =>
                    group.is_admin_group === true
                    && group.members_uid.includes(user.uid)
            );
        }
        return user.level.toLowerCase() === 'manager' && currentUserIsEntityAdmin;
    },
};



// WEBPACK FOOTER //
// ./src/store/getters.js